/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Flickity from "flickity";
require("flickity-sync");
require("flickity-as-nav-for");

/*------------------------------------*\
    PRODUCT GALLERY
\*------------------------------------*/
class CarouselModule {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.carouselElem = self.elem.querySelector('[data-carousel]');
        self.carouselNavElem = self.elem.querySelector('[data-carousel-nav]');
    }

    init() {
        let self = this;

        self.getCarousels();
    }

    getCarousels() {
        let self = this;

        self.getCarousel();
        self.getCarouselNav();
    }

    getCarousel() {
        let self = this;

        const flktyPrimary = new Flickity(self.carouselElem, {
            contain: true,
            pageDots: false,
            wrapAround: true
        });
    }

    getCarouselNav() {
        let self = this;

        const flktySecondary = new Flickity(self.carouselNavElem, {
            asNavFor: ".carousel--main",
            contain: true,
            draggable: false,
            groupCells: 3,
            pageDots: false,
            percentPosition: false
        });
    }
}

export default CarouselModule;
